import React from "react";
import PremiumResourcePage, { resourceMoney, resourceStatus } from "../../../Components/Dashboard/PremiumResourcePage";
import CreditNotesUpdate from "../SalesNew/CreditNotesUpdate";

const CreditNotes = ({ navigation }) => (
  <PremiumResourcePage
    navigation={navigation}
    title="Credit Notes"
    subtitle="Manage issued credit notes, references, customers, and balances."
    createRoute="CreditNoteNew"
    createLabel="+ New Credit Note"
    fetchEndpoint="/fetchCreditNotes"
    fetchBody={{ fromDate: "", toDate: "" }}
    documentType="credit_note"
    deleteEndpoint="/deleteByCreditNoteNumber/:id"
    deleteKey="creditNoteNumber"
    totalKey="total"
    renderEdit={(row, handleCancel) => (
      <CreditNotesUpdate
        creditNoteNumber={row.creditNoteNumber}
        fetchedStatus={row.status}
        handleCancel={handleCancel}
      />
    )}
    columns={[
      { key: "serial", label: "Serial No." },
      { key: "creditNoteDate", label: "Date" },
      { key: "creditNoteNumber", label: "Credit Note #" },
      { key: "reference", label: "Reference" },
      { key: "customerName", label: "Customer Name" },
      { key: "status", label: "Status", render: (row) => resourceStatus(row.status) },
      { key: "total", label: "Total", className: "premium-money", render: (row) => resourceMoney(row.total) },
    ]}
  />
);

export default CreditNotes;
